import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class SlackOAuthAuthedUser extends PrimitiveValueObject<string> {
  static create(value: string): SlackOAuthAuthedUser {
    return new SlackOAuthAuthedUser(value);
  }
}
